import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import './HomePage.css';

const HomePage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [isAnimating, setIsAnimating] = useState(false);

  // Animation effect on mount
  useEffect(() => {
    setIsAnimating(true);
    // No timeout to turn off animation
    return () => {};
  }, []);

  const handleStartQuickTest = () => {
    navigate('/quick-test');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="home-page">
      <main className="home-main">
        <div className={`hero-section ${isAnimating ? 'animate' : ''}`}>
          <div className="hero-content">
            <h1 className="hero-title">{t('discoverYourself')}</h1>
            <p className="hero-subtitle">{t('quickTestDescription')}</p>
            <button className="start-test-button" onClick={handleStartQuickTest}>
              <span className="button-text">{t('startQuickTest')}</span>
              <span className="button-icon">→</span>
            </button>
          </div>
          <div className="hero-visual">
            <div className="brain-animation">
              <div className="brain-paths">
                <div className="path path-1"></div>
                <div className="path path-2"></div>
                <div className="path path-3"></div>
                <div className="path path-4"></div>
                <div className="path path-5"></div>
              </div>
              <div className="brain-shape"></div>
            </div>
          </div>
        </div>

        <div className="features-section">
          <div className="feature-card">
            <div className="feature-icon">⏱️</div>
            <h3>{t('quickAndEasy')}</h3>
            <p>{t('quickAndEasyDesc')}</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🧠</div>
            <h3>{t('scientificApproach')}</h3>
            <p>{t('scientificApproachDesc')}</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>{t('privateAndSecure')}</h3>
            <p>{t('privateAndSecureDesc')}</p>
          </div>
        </div>

        <div className="cta-section">
          <h2>{t('readyToDiscover')}</h2>
          <p>{t('readyToDiscoverDesc')}</p>
          <button className="cta-button" onClick={handleStartQuickTest}>
            {t('startNow')}
          </button>
        </div>
      </main>

      <footer className="home-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('company')}</h3>
            <div className="footer-links">
              <span onClick={() => navigate('/about')}>{t('about')}</span>
              <span onClick={() => navigate('/contact')}>{t('contact')}</span>
            </div>
          </div>
          <div className="footer-section">
            <h3>{t('legal')}</h3>
            <div className="footer-links">
              <span onClick={() => navigate('/privacy')}>{t('privacyPolicy')}</span>
              <span onClick={() => navigate('/terms')}>{t('termsOfService')}</span>
            </div>
          </div>
          <div className="footer-section">
            <h3>{t('followUs')}</h3>
            <div className="social-links">
              <a href="https://twitter.com/whomii" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://facebook.com/whomii" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://instagram.com/whomii" target="_blank" rel="noopener noreferrer">Instagram</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Whomii. {t('allRightsReserved')}</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage; 